export const CATEGORIES = [
  ["top", "Parte de cima"],
  ["bottom", "Parte de baixo"],
  ["dress", "Vestidos"],
  ["outerwear", "Casacos"],
  ["shoes", "Calçados"],
  ["accessory", "Acessórios"],
  ["other", "Outros"],
];

export const categoryLabel = (value) =>
  CATEGORIES.find(([category]) => category === value)?.[1] || value;

export { resolveAssetUrl as imageUrl } from "../../services/apiConfig";
